var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g, _g2, _g3, _path21, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIllustrationZeroHassle = function SvgIllustrationZeroHassle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 160,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-zero-hassle_svg__a)",
    d: "M135.72 85c0 37.555-23.59 68-52.69 68s-52.69-30.445-52.69-68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-zero-hassle_svg__b)",
    d: "M112.381 85c0 37.555-23.59 68-52.69 68s-52.69-30.445-52.69-68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-zero-hassle_svg__c)",
    d: "M124.051 85c0 37.555-23.59 68-52.69 68s-52.69-30.445-52.69-68"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-zero-hassle_svg__d)",
    d: "M147.39 85c0 37.555-23.59 68-52.69 68s-52.69-30.445-52.69-68"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-zero-hassle_svg__e)",
    d: "M159.059 85c0 37.555-23.59 68-52.69 68s-52.69-30.445-52.69-68"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-zero-hassle_svg__f)",
    d: "M182.398 85c0 37.555-23.589 68-52.689 68s-52.69-30.445-52.69-68"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-zero-hassle_svg__g)",
    d: "M194.067 85c0 37.555-23.59 68-52.689 68-29.1 0-52.69-30.445-52.69-68"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-zero-hassle_svg__h)",
    d: "M217.406 85c0 37.555-23.59 68-52.689 68-29.1 0-52.69-30.445-52.69-68"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-zero-hassle_svg__i)",
    d: "M170.728 85c0 37.555-23.589 68-52.689 68s-52.69-30.445-52.69-68"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-zero-hassle_svg__j)",
    d: "M205.736 85c0 37.555-23.59 68-52.689 68-29.1 0-52.69-30.445-52.69-68"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-zero-hassle_svg__k)",
    d: "M164.717 85c0 37.555 23.59 68 52.689 68 29.1 0 52.69-30.445 52.69-68"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-zero-hassle_svg__l)",
    d: "M188.056 85c0 37.555 23.59 68 52.689 68 29.1 0 52.69-30.445 52.69-68"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-zero-hassle_svg__m)",
    d: "M176.386 85c0 37.555 23.59 68 52.689 68 29.1 0 52.69-30.445 52.69-68"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-zero-hassle_svg__n)",
    d: "M153.048 85c0 37.555 23.59 68 52.689 68 29.1 0 52.69-30.445 52.69-68"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-zero-hassle_svg__o)",
    d: "M141.378 85c0 37.555 23.59 68 52.689 68 29.1 0 52.69-30.445 52.69-68"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-zero-hassle_svg__p)",
    d: "M118.039 85c0 37.555 23.59 68 52.69 68s52.689-30.445 52.689-68"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-zero-hassle_svg__q)",
    d: "M106.369 85c0 37.555 23.59 68 52.69 68s52.689-30.445 52.689-68"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-zero-hassle_svg__r)",
    d: "M83.03 85c0 37.555 23.59 68 52.69 68s52.689-30.445 52.689-68"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-zero-hassle_svg__s)",
    d: "M129.708 85c0 37.555 23.59 68 52.689 68 29.1 0 52.69-30.445 52.69-68"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-zero-hassle_svg__t)",
    d: "M94.7 85c0 37.555 23.59 68 52.69 68s52.689-30.445 52.689-68"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-zero-hassle_svg__u)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-zero-hassle_svg__v)",
    d: "M150.33 142.019 74 117.221l74.946-26.037 76.33 24.797z",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-zero-hassle_svg__w)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-zero-hassle_svg__x)",
    d: "M150.33 120.291 74 95.493l74.946-26.037 76.33 24.798z",
    shapeRendering: "crispEdges"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-zero-hassle_svg__y)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-zero-hassle_svg__z)",
    d: "M150.33 98.563 74 73.766l74.946-26.038 76.33 24.798z",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-zero-hassle_svg__A)",
    opacity: 0.4
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#634F69",
    fillOpacity: 0.45,
    d: "M150.33 76.835 74 52.038 148.946 26l76.33 24.798z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-zero-hassle_svg__B)",
    d: "M150.33 76.835 74 52.038 148.946 26l76.33 24.798z",
    style: {
      mixBlendMode: "overlay"
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-zero-hassle_svg__a",
    x1: 62.697,
    x2: 135.72,
    y1: 119,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#F5C0C0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A152F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-zero-hassle_svg__b",
    x1: 39.358,
    x2: 112.381,
    y1: 119,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#F5C0C0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A152F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-zero-hassle_svg__c",
    x1: 51.028,
    x2: 124.051,
    y1: 119,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#F5C0C0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A152F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-zero-hassle_svg__d",
    x1: 74.367,
    x2: 147.39,
    y1: 119,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#F5C0C0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A152F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-zero-hassle_svg__e",
    x1: 86.036,
    x2: 159.059,
    y1: 119,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#F5C0C0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A152F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-zero-hassle_svg__f",
    x1: 109.376,
    x2: 182.398,
    y1: 119,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#F5C0C0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A152F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-zero-hassle_svg__g",
    x1: 121.045,
    x2: 194.067,
    y1: 119,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#F5C0C0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A152F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-zero-hassle_svg__h",
    x1: 144.384,
    x2: 217.406,
    y1: 119,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#F5C0C0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A152F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-zero-hassle_svg__i",
    x1: 97.706,
    x2: 170.728,
    y1: 119,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#F5C0C0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A152F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-zero-hassle_svg__j",
    x1: 132.714,
    x2: 205.736,
    y1: 119,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#F5C0C0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A152F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-zero-hassle_svg__k",
    x1: 237.739,
    x2: 164.717,
    y1: 119,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#F5C0C0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A152F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-zero-hassle_svg__l",
    x1: 261.078,
    x2: 188.056,
    y1: 119,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#F5C0C0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A152F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-zero-hassle_svg__m",
    x1: 249.408,
    x2: 176.386,
    y1: 119,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#F5C0C0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A152F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-zero-hassle_svg__n",
    x1: 226.07,
    x2: 153.048,
    y1: 119,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#F5C0C0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A152F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-zero-hassle_svg__o",
    x1: 214.401,
    x2: 141.378,
    y1: 119,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#F5C0C0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A152F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-zero-hassle_svg__p",
    x1: 191.062,
    x2: 118.039,
    y1: 119,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#F5C0C0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A152F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-zero-hassle_svg__q",
    x1: 179.392,
    x2: 106.369,
    y1: 119,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#F5C0C0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A152F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-zero-hassle_svg__r",
    x1: 156.053,
    x2: 83.03,
    y1: 119,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#F5C0C0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A152F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-zero-hassle_svg__s",
    x1: 202.731,
    x2: 129.708,
    y1: 119,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#F5C0C0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A152F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-zero-hassle_svg__t",
    x1: 167.723,
    x2: 94.7,
    y1: 119,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#F5C0C0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A152F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-zero-hassle_svg__v",
    x1: 225.276,
    x2: 76.576,
    y1: 99.656,
    y2: 119.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01011B",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#01011B",
    stopOpacity: 0.58
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-zero-hassle_svg__x",
    x1: 225.276,
    x2: 76.576,
    y1: 77.928,
    y2: 97.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#F5C0C0",
    stopOpacity: 0.14
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-zero-hassle_svg__z",
    x1: 263.613,
    x2: 77.634,
    y1: 55.853,
    y2: 81.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07052E",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8EB6",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-zero-hassle_svg__B",
    x1: 75.727,
    x2: 210.722,
    y1: 50.207,
    y2: 50.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#F5C0C0",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-zero-hassle_svg__u",
    width: 157.275,
    height: 57.835,
    x: 71,
    y: 89.184,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_845_20592"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_845_20592",
    result: "effect2_dropShadow_845_20592"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 1,
    result: "effect3_dropShadow_845_20592"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_845_20592",
    result: "effect3_dropShadow_845_20592"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_845_20592",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-zero-hassle_svg__w",
    width: 157.275,
    height: 57.835,
    x: 71,
    y: 67.456,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_845_20592"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_845_20592",
    result: "effect2_dropShadow_845_20592"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 1,
    result: "effect3_dropShadow_845_20592"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_845_20592",
    result: "effect3_dropShadow_845_20592"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_845_20592",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-zero-hassle_svg__y",
    width: 157.275,
    height: 57.835,
    x: 71,
    y: 45.728,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_845_20592"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_845_20592",
    result: "effect2_dropShadow_845_20592"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 1,
    result: "effect3_dropShadow_845_20592"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_845_20592",
    result: "effect3_dropShadow_845_20592"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_845_20592",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-zero-hassle_svg__A",
    width: 183.275,
    height: 82.835,
    x: 58,
    y: 18,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_845_20592"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_845_20592",
    result: "effect2_dropShadow_845_20592"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 1,
    result: "effect3_dropShadow_845_20592"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_845_20592",
    result: "effect3_dropShadow_845_20592"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_845_20592",
    result: "shape"
  })))));
};
export { SvgIllustrationZeroHassle as ReactComponent };
export default __webpack_public_path__ + "static/illustration-zero-hassle.34885739.svg";